module.exports = __webpack_public_path__ + "img/air4.ec92ee61.jpg";